import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { faCog, faUser, faToggleOn, faToggleOff } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Settings.css';
import { useAppConfig } from '../../AppConfigProvider';
import ExpenseAccountManager from './ExpenseAccountManager';
import PayableAccountManager from './PayableAccountManager';

const Settings = ({uId}) => {
  const appConfig = useAppConfig();
  const userID = uId;

  const [isTaxRegistered, setIsTaxRegistered] = useState(false);
  const [settingsLoading, setSettingsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('expense');

  // Fetch flag value when the component loads
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${appConfig.backendUrl}api/v1/userSetting/${userID}`);
        console.log("response.data.isTaxRegistered",response.data)
        setIsTaxRegistered(response.data.isTaxRegistered); // Assuming response.data contains flag value
      } catch (error) {
        console.error('Error fetching flag:', error);
      }
    };
    if (userID) {
      fetchData();
    }
  }, [appConfig.backendUrl, userID]);

  // Function to handle checkbox change
  const handleChange = async () => {
    try {
      setSettingsLoading(true);
      const response = await axios.put(`${appConfig.backendUrl}api/v1/userSetting/userTaxDUpdate/${userID}`, {
        isTaxRegistered: !isTaxRegistered // Toggle flag value
      });
      console.log(response.data); // Assuming backend sends back some response
      setIsTaxRegistered(!isTaxRegistered); // Update local state
      
      toast.success(`VAT Registration ${!isTaxRegistered ? 'enabled' : 'disabled'} successfully!`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
    } catch (error) {
      console.error('Error updating flag:', error);
      toast.error('Failed to update VAT registration status. Please try again.', {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
    } finally {
      setSettingsLoading(false);
    }
  };
  return (
    <div className="settings-container pushqb-container">
      <div className="page-header">
        <h1 className="page-title">
          <FontAwesomeIcon icon={faCog} />
          Settings
        </h1>
        <p className="page-subtitle">Manage your account preferences and configurations</p>
      </div>
      
      {/* User Preferences Section */}
      <div className="settings-section">
        <div className="section-header">
          <h2 className="section-title">
            <FontAwesomeIcon icon={faUser} />
            User Preferences
          </h2>
          <p className="section-description">Configure your account settings</p>
        </div>
        
        <div className="settings-card">
          <div className="setting-item">
            <div className="setting-info">
              <label className="setting-label">VAT Registration Status</label>
              <p className="setting-description">
                Indicate if your company is registered for VAT/Tax purposes
              </p>
            </div>
            <div className="setting-control">
              <button
                className={`toggle-btn ${isTaxRegistered ? 'active' : ''}`}
                onClick={handleChange}
                disabled={settingsLoading}
                aria-label={`VAT Registration: ${isTaxRegistered ? 'Enabled' : 'Disabled'}`}
              >
                <FontAwesomeIcon 
                  icon={isTaxRegistered ? faToggleOn : faToggleOff} 
                  className="toggle-icon"
                />
                <span className="toggle-text">
                  {isTaxRegistered ? 'Registered' : 'Not Registered'}
                </span>
                {settingsLoading && <span className="loading-spinner"></span>}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Account Management Section */}
      <div className="settings-section">
        <div className="section-header">
          <h2 className="section-title">
            <FontAwesomeIcon icon={faCog} />
            Account Management
          </h2>
          <p className="section-description">Manage your expense and payable accounts</p>
        </div>
        
        <div className="account-management">
          {/* Desktop Layout - Two Columns */}
          <div className="desktop-layout">
            <div className="account-column">
              <ExpenseAccountManager uId={uId} />
            </div>
            <div className="account-column">
              <PayableAccountManager uId={uId} />
            </div>
          </div>
          
          {/* Mobile Layout - Tabs */}
          <div className="mobile-layout">
            <div className="tab-navigation">
              <button 
                className={`tab-btn ${activeTab === 'expense' ? 'active' : ''}`}
                onClick={() => setActiveTab('expense')}
              >
                Expense Accounts
              </button>
              <button 
                className={`tab-btn ${activeTab === 'payable' ? 'active' : ''}`}
                onClick={() => setActiveTab('payable')}
              >
                Payable Accounts
              </button>
            </div>
            
            <div className="tab-content">
              {activeTab === 'expense' && <ExpenseAccountManager uId={uId} />}
              {activeTab === 'payable' && <PayableAccountManager uId={uId} />}
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  )
}

export default Settings